let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("6MqYI")).then(() => parcelRequire('c14L5'));